import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext.hook';
import { AdminLayout } from './AdminLayout';
import { PartnerLayout } from './PartnerLayout';
import { AssessorLayout } from './AssessorLayout';
import { InvestorLayout } from './InvestorLayout';
import { IncorporadorLayout } from './IncorporadorLayout';
import { DiligenciasManagerLayout } from './DiligenciasManagerLayout';
import { LumaSpin } from '@/components/ui/luma-spin';

interface RoleBasedLayoutProps {
  children: React.ReactNode;
}

/**
 * Component that renders the appropriate layout based on the user's role.
 * Used for shared routes that should maintain their respective panel layouts.
 */
export const RoleBasedLayout: React.FC<RoleBasedLayoutProps> = ({ children }) => {
  const { profile, loading } = useAuth();

  // Wait for profile to load
  if (loading || !profile) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LumaSpin size="lg" />
      </div>
    );
  }

  // Determine which layout to use based on user role
  const role = profile.role;

  switch (role) {
    case 'admin':
      return <AdminLayout>{children}</AdminLayout>;

    case 'partner':
    case 'mfb':
    case 'mfa':
      return <PartnerLayout>{children}</PartnerLayout>;

    case 'assessor':
      return <AssessorLayout>{children}</AssessorLayout>;

    case 'investidor':
      return <InvestorLayout>{children}</InvestorLayout>;

    case 'incorporador':
      return <IncorporadorLayout>{children}</IncorporadorLayout>;

    case 'diligencias_manager':
      return <DiligenciasManagerLayout>{children}</DiligenciasManagerLayout>;

    default:
      console.warn('[RoleBasedLayout] Unknown role, falling back to InvestorLayout:', role);
      return <InvestorLayout>{children}</InvestorLayout>;
  }
};
